import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const Container = styled.span(({ theme }) => ({
  color: theme.palette.erieBlack,
  display: 'flex',
  gap: '10rem',
  alignItems: 'center',
  flexShrink: 0,

  height: 'auto',
  paddingInline: '10rem',
  paddingBlock: '8rem',
  backgroundColor: theme.palette.desertSand,
  borderRadius: '20rem',
  boxShadow: `${theme.card.primary.shadow} 0rem 2rem 3rem`,

  fontSize: theme.typography.size14,
}));

export const CloseButton = styled(CommonButton)(({ theme }) => ({
  height: '16rem',
  backgroundColor: theme.palette.black,
  color: theme.palette.desertSand,
  padding: '2rem',
  borderRadius: '50%',

  '& .anticon.anticon-close': {
    fontSize: '10rem',
  },
}));
